import { useRef } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import PromoSection from "@/components/PromoSection";
import AudienceSection from "@/components/AudienceSection";
import WhyZulunitySection from "@/components/WhyZulunitySection";
import HowItWorksSection from "@/components/HowItWorksSection";
import LeadForm from "@/components/LeadForm";
import Footer from "@/components/Footer";

const LandingPage = () => {
  const formRef = useRef(null);

  const scrollToForm = () => {
    formRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="min-h-screen" style={{ backgroundColor: "#050505" }}>
      <Header onApplyClick={scrollToForm} />
      <HeroSection onApplyClick={scrollToForm} />
      <PromoSection onApplyClick={scrollToForm} />
      <AudienceSection onApplyClick={scrollToForm} />
      <WhyZulunitySection />
      <HowItWorksSection onApplyClick={scrollToForm} />
      <LeadForm ref={formRef} />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster
          theme="dark"
          toastOptions={{
            style: {
              background: "#141414",
              border: "1px solid rgba(255,255,255,0.1)",
              color: "#fff",
            },
          }}
        />
        <Routes>
          <Route path="/" element={<LandingPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
